// @dokos
export function build_copy_address_preview(emails, separator, translate) {
	const preview = emails.slice(0, 8).join(`${separator} `);
	const remainder = emails.length - 8;
	return `${preview}${remainder > 0 ? `${separator} … ${translate("and {0} others", [remainder])}` : ""}` ||
		translate("No eligible addresses");
}

// @dokos
export function get_copy_address_page(emails, page, page_length) {
	const start = Math.max(0, page) * page_length;
	return emails.slice(start, start + page_length);
}

// @dokos
export function get_selected_copy_addresses(emails, selected_emails) {
	return emails.filter((email) => selected_emails.has(email));
}

// @dokos
export function format_recipient_group_label(label, count, translate) {
	return translate("{0} ({1})", [label, count]);
}

// @dokos
export function build_copy_address_csv(emails, translate) {
	return [[translate("Email")], ...emails.map((email) => [email])];
}
